// components/AddClientModal.js
import React from "react";
import "../Styles/AddClientModal.css";

const AddClientModal = ({ onClose, handleCreateProfile, IsAgentLogin }) => {
  return (
    <div className="modal-overlay1">
      <div className="modal-container">
        <div className="modal-header">
          <span className="modal-title">Add new profile</span>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        <hr />
        <div className="modal-content">
          {IsAgentLogin ?<img
            className="click-effect"
            src={require("../assests/images/new-client-icon.png")}
            alt=""
            onClick={handleCreateProfile}
          /> :
          <img
            className="click-effect new-profile-img "
            src={require("../assests/images/newProfileIcon.png")}
            alt=""
            onClick={handleCreateProfile}
          />}
        </div>
      </div>
    </div>
  );
};

export default AddClientModal;
